import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Unstable_Grid2";
import { CardHeader, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import FinancialTransactionsTable from './financial-transactions-table';
import { getFinancialData } from "../../components/upload/upload";
import { useSettingsContext } from '../../components/settings';
import { fPercentEuroOne } from '../../utils/format-number';


export default function FinancialDetails() {
    const navigate = useNavigate();
    const settings = useSettingsContext();
    const [resumen, setResumen] = useState(() => settings.detailsCache?.resumen || null);
    
    useEffect(() => {
        if (resumen){
            return;
        }
        try {
            const data = getFinancialData();
            if (!data) throw new Error('No data');
            setResumen(data);
            settings.onFiles(); // Solo si tienes datos
            settings.onValid();

            const nuevoCache = {
                resumen: data,
            }

            settings.setDetailsCache(nuevoCache)
        } catch (error) {
            console.warn('No se encontraron datos. Redirigiendo al inicio...');
            navigate('/financial');
        }
    }, [navigate, settings, resumen]);
    
    if (!resumen) return null;

    return (
        <Grid container spacing={2} direction="column">
            <Grid item xs={12}>
                <Typography variant="h4" fontWeight="bold" paddingLeft={2}>
                    Detalle del transaccional
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FinancialTransactionsTable
                    tableData={resumen.categorizado}
                    tableLabels={[
                        { id: 'value_date', label: 'Fecha' },
                        { id: 'amount', label: 'Importe' },
                        { id: 'balance_final', label: 'Saldo' },
                        { id: 'concepts', label: 'Concepto' },
                        { id: 'detalle', label: 'Detalle', width: 200 },
                        { id: 'categoria', label: 'Categoría', width: 200 },
                        { id: 'agrupacion', label: 'Agrupación', width: 200 },
                        { id: 'metodo', label: 'Método' },
                    ]}
                />
            </Grid>
            <Grid item xs={12}>
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                            <Card>
                                <CardHeader title='Resumen del método de categorización' />
                                <CardContent>
                                    <Stack spacing={2} sx={{ mt: 1, ml: 1 }}>
                                        <Stack direction="row" spacing={2} alignItems="center" width="100%">
                                            <Card
                                                sx={{
                                                    flex: 1,
                                                    borderRadius: 3,
                                                    boxShadow: 'sm',
                                                    minHeight: 120,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    px: 2,
                                                    py: 1,
                                                }}
                                            >
                                                <Stack direction="row" spacing={2} alignItems="center" width="100%">
                                                    <Box flexGrow={1}>
                                                        <Typography variant="subtitle2">
                                                            LLM
                                                        </Typography>
                                                        <Typography variant="h3" fontWeight="bold">
                                                            {fPercentEuroOne(100 * resumen.metodos_categorizacion.global.llm || '0')}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </Card>
                                            <Card
                                                sx={{
                                                    flex: 1,
                                                    borderRadius: 3,
                                                    boxShadow: 'sm',
                                                    minHeight: 120,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    px: 2,
                                                    py: 1,
                                                }}
                                            >
                                                <Stack direction="row" spacing={2} alignItems="center" width="100%">
                                                    <Box flexGrow={1}>
                                                        <Typography variant="subtitle2">
                                                            TAGS
                                                        </Typography>
                                                        <Typography variant="h3" fontWeight="bold">
                                                            {fPercentEuroOne(100 * resumen.metodos_categorizacion.global.tags || '0')}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </Card>
                                        </Stack>
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Stack>
            </Grid>
        </Grid>
    )
}